// extracted by mini-css-extract-plugin
module.exports = {"wechat":"BindWechat_style_wechat__2lWGG"};